window.addEventListener('load', function () {
    if (document.querySelectorAll('.headerSlider').length) {
        const elements = document.querySelectorAll('.headerSlider');

        elements.forEach(function (element) {
            let headerSlider = new Swiper(element.querySelector('.swiper'), {
                watchOverflow: true,
                lazy: true,
                preloadImages: false,
                loadPrevNext: true,
                checkInView: true,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },

                pagination: {
                    el: element.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });
        });
    }
});
